















import Vue from 'vue';
import HotelImageCarousel from '@/components/landing/HotelImageCarousel.vue';

export default Vue.extend({
  name: 'RoomDetailsModal',
  components: {
    HotelImageCarousel,
  },
  props: {
    room: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    roomName(): string {
      if (!this.room || !this.room.name) {
        return '';
      }
      return this.room.name[this.i18nTag()] ? this.room.name[this.i18nTag()] : this.room.name.en;
    },
    roomDescription(): string {
      if (!this.room || !this.room.description) {
        return '';
      }
      let description = this.room.description[this.i18nTag()]
        ? this.room.description[this.i18nTag()]
        : this.room.description.en;
      description = description ? description.replace(/\r?\n/gi, '<br>') : '';
      return description;
    },
  },
  mounted() {},
  methods: {},
});
